import React from 'react';
import { Button } from '../components/common/Button';

interface IProps {
  setVideo: () => void;
}

const FailLoad: React.FC<IProps> = ({ setVideo }) => (
  <div className="fail-load-page flex column align-center justify-center">
    <h3>We couldn&apos;t get the video</h3>
    <Button cbFunction={setVideo}>Try again</Button>
  </div>
);

export default FailLoad;
